import PageLayout from "./components/PageLayout";

function Notifications() {
  return (
    <PageLayout
      eyebrow="Notifications"
      title="Nothing new yet."
      subtitle="When builders you follow update their builds, receive comments, or your listings get activity, you'll see it all here."
    >
      <div style={emptyCardStyle}>
        🔔

        <h2 style={emptyTitleStyle}>
          You're all caught up
        </h2>

        <p style={emptyTextStyle}>
          Notifications will begin appearing as the MyBuildID community grows.
        </p>
      </div>
    </PageLayout>
  );
}

const emptyCardStyle = {
  marginTop: "40px",
  backgroundColor: "#181818",
  border: "1px solid #2a2a2a",
  borderRadius: "20px",
  padding: "36px 24px",
  textAlign: "center",
  fontSize: "42px",
};

const emptyTitleStyle = {
  marginTop: "18px",
  marginBottom: "8px",
};

const emptyTextStyle = {
  opacity: 0.7,
  lineHeight: "1.6",
};

export default Notifications;